import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { PoolID } from '~src/settings/general-settings/components/sections/bridge/types/PoolID';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDeleteEdgePoolsParams {
  poolIds: PoolID[];
  bridgeSettingsVersion: string;
  siteId: string;
}

export interface IDeleteEdgePoolsResult extends IResult {
  success?: {
    poolIds: PoolID[];
    siteID: string;
  };
  error?: {
    errorCode: string;
  };
  bridgeSettingsVersion: string;
}

export class DeleteEdgePoolsRequest extends Request<IDeleteEdgePoolsParams, IDeleteEdgePoolsResult> {
  constructor(params: IDeleteEdgePoolsParams) {
    super('deleteEdgePools', params);
  }
}
